module.exports = __webpack_public_path__ + "img/embalatge-packetgrup.18b131f9.jpg";